import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mainContext from "../context/mainContext";
import { addCardsFromSaveWordsApi } from "../services/leitnerApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";
import { getDetalisListOfUserWordsApi } from "../services/userSaveWordApi";
import { hasPremiumAccess, redirectToSubscription } from "../utils/premiumCheck";

export default function WordTransfer() {
  const { boxesList, userTypes } = useContext(mainContext);
  const nav = useNavigate();
  const [boxId, setBoxId] = React.useState("");
  const [fromLang, setFromLang] = React.useState("en");
  const [toLang, setToLang] = React.useState("fa");
  const [wordsList, setWordsList] = React.useState([]);
  const [doneTransfer, setDoneTransfer] = React.useState(0);
  const [activeLitnerSelector, setActiveLitnerSelector] = React.useState(false);
  const [inProgress, setInProgress] = React.useState({ active: false, message: "" });

  const handleInProgress = (data) => setInProgress(data);

  const handleWordsList = (changeLang, words) => {
    setDoneTransfer(0);
    if (changeLang) {
      setWordsList([]);
      setActiveLitnerSelector(false);
    } else {
      setWordsList(words);
      setActiveLitnerSelector(true);
    }
  };

  const languages = {
    en: "انگلیسی", de: "المانی", fr: "فرانسوی",
    fa: "فارسی", tr: "ترکی", it: "ایتالیایی",
  };

  const checkWordList = async () => {
    try {
      let nextPage = true;
      let pageNumber = 1;
      let allWords = [];
      handleInProgress({ active: true, message: "در حال دریافت لیست لغات" });
      while (nextPage) {
        const response = await getDetalisListOfUserWordsApi(
          { fromLang, toLang },
          { perPage: 50, page: pageNumber }
        );
        let res = checkResponseData(response);
        if (res["data"] && res["data"]["docs"]) {
          nextPage = res["data"]["hasNextPage"];
          res["data"]["docs"].forEach((wrd) => {
            let newWord = {};
            [
              "_id", "userId", "fromLang", "toLang", "word", "meanings",
              "subtitle", "translateOfSubtitle", "subtitleStartTime",
              "subtitleEndTime", "movieName", "season", "episode",
              "pictures", "levelForUser", "situation", "groups", "createdAt",
            ].forEach((el) => { if (wrd[el]) newWord[el] = wrd[el]; });
            allWords.push(newWord);
          });
          pageNumber++;
        } else {
          nextPage = false;
        }
      }
      handleWordsList(false, allWords);
      handleInProgress({ active: false, message: "" });
    } catch (error) {
      handleInProgress({ active: false, message: "" });
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در دریافت اطلاعات وجود دارد");
    }
  };

  const submit = async (e) => {
    handleInProgress({ active: true, message: "در حال انتقال لغات به لایتنر" });
    e.preventDefault();
    try {
      let data = { boxId, cards: wordsList, deletedWords: false };
      let response = await addCardsFromSaveWordsApi(data);
      const res = checkResponseData(response);
      if (res["success"]) {
        setTimeout(() => setDoneTransfer(wordsList.length), 500);
        toast.success(res["message"] || "انتقال با موفقیت انجام شد");
        handleWordsList(true, []);
      } else {
        toast.error(res["message"] || "مشکلی در انتقال لغات وجود دارد");
      }
      handleInProgress({ active: false, message: "" });
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در انتقال اطلاعات وجود دارد");
      handleInProgress({ active: false, message: "" });
    }
  };

  const isPremium = hasPremiumAccess(userTypes);

  if (!isPremium) {
    return (
      <div className="container" style={{ maxWidth: 520 }}>
        <div className="premium-banner">
          <h3>✨ قابلیت ویژه کاربران اوملنگ</h3>
          <p>
            انتقال لغات ذخیره شده به جعبه لایتنر یکی از امکانات ویژه اوملنگ است.
            برای استفاده از این قابلیت، اشتراک ویژه تهیه کنید.
          </p>
          <button className="btn success" onClick={redirectToSubscription} style={{ width: "100%" }}>
            دریافت اشتراک ویژه
          </button>
          <br /><br />
          <button className="btn ghost" onClick={() => nav(-1)} style={{ width: "100%" }}>
            بازگشت
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: 720 }}>
      <div className="card">
        <h2 style={{ marginTop: 0 }}>انتقال لغات به لایتنر</h2>
        <form onSubmit={submit}>
          <p className="label">1- انتخاب لغات ذخیره شده</p>
          <div className="row" style={{ marginTop: 12 }}>
            <div style={{ flex: 1, marginRight: 8 }}>
              <label className="label">زبان اول (لغات)</label>
              <select
                className="input"
                value={fromLang}
                onChange={(e) => { setFromLang(e.target.value); handleWordsList(true, 0); }}
              >
                {Object.entries(languages).map(([key, label]) => (
                  <option key={key} value={key}>{label}</option>
                ))}
              </select>
            </div>
            <div style={{ flex: 1, marginLeft: 8 }}>
              <label className="label">زبان دوم (ترجمه)</label>
              <select
                className="input"
                value={toLang}
                onChange={(e) => { setToLang(e.target.value); handleWordsList(true, 0); }}
              >
                {Object.entries(languages).map(([key, label]) => (
                  <option key={key} value={key}>{label}</option>
                ))}
              </select>
            </div>
            <div style={{ flex: 1, marginLeft: 8 }}>
              <label className="label">تعداد لغات</label>
              <button
                type="button"
                disabled={inProgress["active"]}
                onClick={checkWordList}
                className={`btn ${inProgress["active"] ? "muted" : ""}`}
                style={{ width: "100%" }}
              >
                {inProgress["active"] ? "..." : "بررسی"}
              </button>
            </div>
          </div>
          {activeLitnerSelector ? (
            <p className="label" style={{ color: "var(--success)", marginTop: 8 }}>
              ✓ تعداد {wordsList.length} لغت آماده انتقال است
            </p>
          ) : null}
          <div
            style={{
              marginTop: 16,
              opacity: activeLitnerSelector ? 1 : 0.5,
              pointerEvents: activeLitnerSelector ? "auto" : "none",
            }}
          >
            <label className="label">2- انتخاب لایتنر مقصد</label>
            <select
              className="input"
              disabled={!activeLitnerSelector}
              value={boxId}
              onChange={(e) => setBoxId(e.target.value)}
            >
              <option value={""}>انتخاب کنید</option>
              {boxesList.map((box) => (
                <option key={box._id} value={box._id}>{box.name}</option>
              ))}
            </select>
            {wordsList.length !== 0 && boxId === "" ? (
              <p className="label" style={{ color: "var(--danger)", marginTop: 4 }}>
                جعبه لایتنر را انتخاب کنید
              </p>
            ) : null}
          </div>
          <div className="row" style={{ marginTop: 20, justifyContent: "flex-end" }}>
            <button className="btn ghost" type="button" onClick={() => nav(-1)}>
              انصراف
            </button>
            <button
              disabled={!activeLitnerSelector || boxId === "" || wordsList.length === 0}
              className="btn"
              type="submit"
            >
              انتقال لغات به لایتنر
            </button>
          </div>
        </form>
        {inProgress["active"] ? (
          <div className="center" style={{ marginTop: 16, gap: 8 }}>
            <div className="spinner small"></div>
            <span style={{ color: "var(--text-secondary)" }}>{inProgress["message"]}</span>
          </div>
        ) : null}
        {doneTransfer > 0 ? (
          <div style={{ marginTop: 16, textAlign: "center" }}>
            <p style={{ color: "var(--success)", fontWeight: 600 }}>
              ✓ انتقال {doneTransfer} لغت با موفقیت انجام شد
            </p>
            <p style={{ color: "var(--text-secondary)", fontSize: 13 }}>
              پس از گذشت یک دقیقه می‌توانید مرور لغات را شروع کنید
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
